module.exports = __webpack_public_path__ + "img/icon_navigate.fc16b31c.png";